<div class="close">
  <button mat-dialog-close>
    <img
      alt="close"
      width="24"
      height="24"
      src="../../../assets/images/close.svg"
    />
  </button>
</div>
<div class="title">{{ data.platform_name }} 售后服务</div>
<div class="content">
  <div class="subtitle">
    如果您在购买后对 {{ data.platform_name }}
    有疑问或使用遇到问题，请查看以下选项选择类型：
  </div>
  <mat-spinner [diameter]="86" *ngIf="loading"></mat-spinner>
  <div class="text" *ngFor="let item of problems">
    <img
      src="../../../../assets/images/workorder/Icon3.webp"
      width="31"
      height="26"
      alt=""
    /><span (click)="openProblemDetail(item)">{{ item.problem }}</span>
  </div>

  <div class="button">
    <button (click)="close()">确定</button>
  </div>
</div>
